import React from 'react';

// Single customer quote between FeaturedProject and FAQ.
// Both quote and author are admin-editable via storefront settings.
export default function TestimonialSection({ settings }) {
  return (
    <section className="asg-testimonial asg-reveal">
      <p className="asg-testimonial-quote">
        {settings.testimonial_quote ?? '"ASG transformed our backyard into a space we actually live in. The louvered roof is a game-changer - we use it rain or shine, every single day."'}
      </p>
      <p className="asg-testimonial-author">{settings.testimonial_author ?? 'Sarah & Michael - Dandenong, Melbourne'}</p>
      <div className="asg-testimonial-divider"></div>
    </section>
  );
}
